module.exports = __webpack_public_path__ + "static/how_it_works_art@2x-8ceb37917bf63c0891d80a2deb86e839.png";